import {
  faEye,
  faGear,
  faMagnifyingGlass,
  faPenToSquare,
  faPlus,
  faQrcode,
  faTrash,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Col,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ClientsCard from "../../components/ClientsCard";
import Loader from "../../components/Loader";
import MaidsCard from "../../components/MaidsCard";
import Message from "../../components/Message";
import PaymentsCard from "../../components/PaymentsCard";
import { getAllStaff } from "../../redux/Actions/maidAction";
import {
  getUserDetails,
  impersonateUser,
} from "../../redux/Actions/userAction";
import { USER_REGISTER_RESET } from "../../redux/Constants/userconstants";
// import ClientDetail from "../ClientDetail";
import Register from "../Register";
import StaffDetail from "../StaffDetail";
import {
  clearDeleteResult,
  clearRegisterResult,
  deleteUser,
  listUsers,
} from "../../redux/slices/clientSlice";
import { useNotification } from "../../components/Notification";

const AdminDashboard = ({ onTabChange, setCollapsed }) => {
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  let isProcessing = false;
  const [createdPassword, setCreatedPassword] = useState("");
  const [userListUpdate, setUserListUpdate] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [userToDeleteName, setUserToDeleteName] = useState("");
  const [hotelToEdit, setHotelToEdit] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [screenLoading, setScreenLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const options = { year: "numeric", month: "numeric", day: "numeric" };
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [show, setShow] = useState(false);
  const [staffModal, setStaffModal] = useState(false);
  const [clientDetailsModal, setClientDetailsModal] = useState(false);

  const {
    listLoading: loading,
    clients: hotels,
    listError: error,
    registerSuccess,
    registerError,
    deleteSuccess,
    deleteError,
  } = useSelector((state) => state.client);

  // const { loading, error, users, success } = useSelector(
  //   (state) => state.userList
  // );
  const { staff } = useSelector((state) => state.getAllStaff);
  const { user } = useSelector((state) => state.userDetails);
  const userId = user && user._id;

  const dispatch = useDispatch();
  // --------------------------------------------------- MODAL HANDLERS ------------------------------------------------------
  const handleDeleteModal = () => setDeleteModal(false);
  const handleClose = () => setShow(false);
  const handleStaffModal = () => setStaffModal(false);
  const handleClientDetailsModal = () => setClientDetailsModal(false);
  // --------------------------------------------------- EVENT HANDLERS ----------------------------------------------------
  const handleAddNew = () => {
    dispatch({ type: USER_REGISTER_RESET });
    setShow(true);
  };
  const handleEditClient = (id) => {
    if (isProcessing) return;
    isProcessing = true;
    try {
      onTabChange("#editClient", id);
      setCollapsed(true);
    } finally {
      isProcessing = false;
    }
  };

  const handleEditSettings = (id) => {
    if (isProcessing) return;
    isProcessing = true;
    try {
      onTabChange("#editSettings", id);
      setCollapsed(true);
    } finally {
      isProcessing = false;
    }
  };
  const handleView = (client) => {
    if (isProcessing) return;
    isProcessing = true;
    setScreenLoading(true);
    setTimeout(() => {
      dispatch(impersonateUser(client._id, client.email, navigate));
      dispatch(getUserDetails());
      isProcessing = false;
    }, 1000);
  };
  const handleDelete = () => {
    if (userToDelete) {
      dispatch(deleteUser(userToDelete));
    }
  };
  // const getDevPartner = (partnerId) => {
  //   if (user) {
  //     const partnerUser = users.find((user) => user._id === partnerId);
  //     if (partnerUser) {
  //       return partnerUser.name;
  //     }
  //   }
  //   return "Not defined";
  // };
  const handleFilter = useCallback(() => {
    if (selectedFilter === "all") {
      setFilteredHotels(hotels);
    } else if (selectedFilter === "b2b") {
      const b2bHotels = hotels.filter((hotel) => hotel.model.b2b === true);
      setFilteredHotels(b2bHotels);
    } else if (selectedFilter === "b2c") {
      const b2cHotels = hotels.filter((hotel) => hotel.model.b2c === true);
      setFilteredHotels(b2cHotels);
    } else if (selectedFilter === "partner") {
      const partnerHotels = hotels.filter(
        (hotel) => hotel.partnerId !== "65b949bd84febb1899b71e0e"
      );
      setFilteredHotels(partnerHotels);
    }
  }, [hotels, selectedFilter]);

  useEffect(() => {
    dispatch(listUsers());
    dispatch(getAllStaff());
    dispatch(getUserDetails());
  }, [dispatch, registerSuccess, deleteSuccess]);

  useEffect(() => {
    if (registerSuccess) {
      handleClose();
      showNotification("User created successfully!", "success");
      dispatch(clearRegisterResult());
    }
    if (deleteSuccess) {
      setUserToDelete(null);
      setUserToDeleteName("");
      setDeleteModal(false);
      showNotification("User deleted successfully!", "success");
      dispatch(clearDeleteResult());
    }
    if (deleteError) {
      showNotification(deleteError, "danger");
    }
    // if (registerError) {
    //   showNotification(registerError, "danger");
    // }
  }, [
    registerSuccess,
    registerError,
    deleteSuccess,
    deleteError,
    showNotification,
  ]);

  useEffect(() => {
    handleFilter();
  }, [handleFilter, selectedFilter]);

  const styles = {
    shadow: {
      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    },
    shadowCard: {
      boxShadow:
        " rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px",
    },
  };
  return (
    <>
      {/* --------------------------------------------------- CLIENT DETAIL MODAL ------------------------------------------ */}
      <Modal
        show={clientDetailsModal}
        onHide={handleClientDetailsModal}
        backdrop="static"
        fullscreen
        centered
      >
        <Modal.Header className="bg-primary">
          <Row className="w-100 align-items-center">
            <Col className="text-center text-light fs-4"></Col>
            <Col md="auto" className="ms-auto p-0 d-inline">
              <Button
                variant="outline-light p-0 px-1  m-0 border-0"
                onClick={handleClientDetailsModal}
              >
                <FontAwesomeIcon className="fs-4" icon={faXmark} />
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          {/* <ClientDetail staff={staff && staff} clients={hotels} /> */}
        </Modal.Body>
      </Modal>
      {/* --------------------------------------------------- STAFF DETAIL MODAL ------------------------------------------ */}
      <Modal
        show={staffModal}
        onHide={handleStaffModal}
        backdrop="static"
        fullscreen
        centered
      >
        <Modal.Header className="bg-primary">
          <Row className="w-100 align-items-center">
            <Col className="text-center text-light fs-4"></Col>
            <Col md="auto" className="ms-auto p-0 d-inline">
              <Button
                variant="outline-light p-0 px-1  m-0 border-0"
                onClick={handleStaffModal}
              >
                <FontAwesomeIcon className="fs-4" icon={faXmark} />
              </Button>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body>
          <StaffDetail hotels={hotels} staff={staff} />
        </Modal.Body>
      </Modal>
      {/* --------------------------------------------------- DELETE MODAL ------------------------------------------ */}
      <Modal
        show={deleteModal}
        onHide={handleDeleteModal}
        backdrop="static"
        centered
      >
        <Modal.Body className="p-4 text-center">
          <b>
            Are you sure you want to remove
            <span className="text-danger mx-1">
              {userToDeleteName !== "" && userToDeleteName}
            </span>
            ?
          </b>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      {/* --------------------------------------------------- ADD NEW MODAL ----------------------------------------- */}
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Client</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Register userId={userId} handleClose={handleClose} />
        </Modal.Body>
      </Modal>
      {/* --------------------------------------------------  CARDS ------------------------------------------------- */}
      {userId === "65b949bd84febb1899b71e0e" && (
        <Row className="justify-content-evenly row-gap-3 p-3 mt-3">
          <Col sm={12} md={5} lg={4} xl={3}>
            <Card
              className="rounded-4 border-0 hover-effect"
              style={styles.shadow}
              // onClick={() => {
              //   staff.length <= 0
              //     ? alert("Please wait for the data")
              //     : setClientDetailsModal(true);
              // }}
            >
              <Card.Body className="p-4">
                <ClientsCard clients={hotels} />
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={5} lg={4} xl={3}>
            <Card
              className="rounded-4 border-0 hover-effect"
              style={styles.shadow}
              // onClick={() => {
              //   staff.length <= 0
              //     ? alert("Please wait for the data")
              //     : setStaffModal(true);
              // }}
            >
              <Card.Body className="p-4">
                <MaidsCard staff={staff} />
              </Card.Body>
            </Card>
          </Col>
          <Col sm={12} md={5} lg={4} xl={3}>
            <Card
              className="rounded-4 border-0 hover-effect"
              style={styles.shadow}
            >
              <Card.Body className="p-4">
                <PaymentsCard />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
      {/* ----------------------------------------------- ADD NEW BUTTON --------------------------------- */}
      <Row className="align-items-center justify-content-end row-gap-3 mt-3">
        <Col xs={6} md={2} className="ms-md-auto">
          <Form.Select
            className="rounded-3 "
            value={selectedFilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="b2b">B2B</option>
            <option value="b2c">B2C</option>
            <option value="partner">Dev Partner Client</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={3} className="">
          <InputGroup className="ms-auto border border-1 rounded-3 ">
            <Button className="bg-transparent border-0" id="button-addon1">
              <FontAwesomeIcon
                icon={faMagnifyingGlass}
                className="text-primary"
              />
            </Button>
            <Form.Control
              className="border-0"
              aria-label="search"
              aria-describedby="basic-addon1"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </InputGroup>
        </Col>

        <Col sm="auto" className="me-3">
          <Button className="px-3 rounded-3" onClick={handleAddNew}>
            <FontAwesomeIcon icon={faPlus} className="me-2" /> Add new
          </Button>
        </Col>
      </Row>
      {/* ---------------------------------------------- HOTELS TABLE ------------------------------------------ */}
      <Row className="p-3 my-3">
        <Col className="p-3 py-4 rounded-4" style={styles.shadow}>
          {loading ? (
            <Row className="justify-content-center">
              <Col sm="auto">
                <Loader />
              </Col>
            </Row>
          ) : error ? (
            <Row className="justify-content-center">
              <Col sm="auto">
                <Message>{error}</Message>
              </Col>
            </Row>
          ) : (
            <div className="table-responsive">
              {" "}
              <Table hover responsive className="align-middle">
                {" "}
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Client Name</th>
                    <th>Contact Person</th>
                    <th>Location</th>
                    <th className="text-center">Actions</th>{" "}
                    {/* Align Actions header */}
                  </tr>
                </thead>
                <tbody>
                  {(filteredHotels?.length > 0 ? filteredHotels : hotels)
                    .filter((hotel) =>
                      hotel.companyName
                        ?.toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    )
                    .slice()
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map((hotel, index) => (
                      <tr key={hotel._id}>
                        <td>{index + 1}.</td>
                        <td>
                          {new Date(hotel.createdAt).toLocaleDateString(
                            "en-US",
                            options
                          )}
                        </td>
                        <td className="fw-semibold">
                          {/* {hotel.partnerId != "65b949bd84febb1899b71e0e" &&
                          user.isSuperAdmin && (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip>
                                  {getDevPartner(hotel.partnerId)}
                                </Tooltip>
                              }
                            >
                              <FontAwesomeIcon
                                icon={faHandshake}
                                className="me-2 fs-6 text-info hover-effect"
                              />
                            </OverlayTrigger>
                          )} */}
                          {hotel.model.b2b === true &&
                          hotel.isAdminX !== true ? (
                            <span
                              className={`border border-1 py-0 px-1 rounded-1 me-1 fw-normal ${
                                hotel.chargesStatus
                                  ? "text-success border-success"
                                  : "text-danger border-danger"
                              }`}
                              style={{ fontSize: "10px" }}
                            >
                              B2B
                            </span>
                          ) : hotel.model.b2b !== true &&
                            hotel.isAdminX !== true ? (
                            <span
                              className={`border border-1 py-0 px-1 rounded-1 me-1 fw-normal text-primary bg-light border-primary`}
                              style={{ fontSize: "10px" }}
                            >
                              B2C
                            </span>
                          ) : null}
                          {hotel.companyName}
                        </td>
                        <td>{hotel.name}</td>
                        <td className="text-success">{hotel.location}</td>
                        <td className="text-center">
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-details-${hotel._id}`}>
                                Edit Details
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-primary"
                              className="btn-sm m-1" // Use btn-sm for smaller buttons, adjust margin
                              onClick={() => {
                                handleEditClient(hotel._id);
                                setCollapsed(true);
                              }}
                            >
                              <FontAwesomeIcon icon={faPenToSquare} />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-details-${hotel._id}`}>
                                Flow Settings
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-primary"
                              className="btn-sm m-1" // Use btn-sm for smaller buttons, adjust margin
                              onClick={() => {
                                handleEditSettings(hotel._id);
                                setCollapsed(true);
                              }}
                            >
                              <FontAwesomeIcon icon={faQrcode} />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-details-${hotel._id}`}>
                                Imporsenate
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-primary"
                              className="btn-sm m-1"
                              onClick={() => {
                                handleView(hotel);
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-details-${hotel._id}`}>
                                Delete
                              </Tooltip>
                            }
                          >
                            <Button
                              variant="outline-danger"
                              className="btn-sm m-1"
                              onClick={() => {
                                setDeleteModal(true);
                                setUserToDelete(hotel._id);
                                setUserToDeleteName(hotel.companyName);
                              }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </Button>
                          </OverlayTrigger>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default AdminDashboard;
